import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "text-danger text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-danger text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first d-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans(`antifraudalerts.rule.${_ctx.alert.rule}`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.data?.dealId), 1),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createVNode(_component_copy_button, {
        value: _ctx.data?.dealId
      }, null, 8, ["value"]),
      _createElementVNode("a", {
        href: `${_ctx.api.baseUrl()}/attachments/${_ctx.data?.attachment}`,
        target: "_blank",
        type: "button",
        class: "me-2 ms-2 text-warning"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
      ]), 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.pay_out_receipt_verification_rule.reason.${_ctx.data?.reason}`)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.trader_blocked')), 1)
    ])
  ]))
}